import React from "react";
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from "../contexts/ThemeContext";
import { BannerContextProvider } from "../contexts/BannerContext";
import NotificationStack from "../components/shared/NotificationStack";

const PublicBannerHost = () => <NotificationStack />;

/**
 * Lightweight layout for public/marketing pages.
 * Does NOT include trading-specific providers:
 * - No PusherProvider (real-time trading alerts)
 * - No WebSocketProvider (trading streams)
 * - No StreamsContextProvider (position/order streams)
 * - No TradingContext, TradingRulesConfig, etc.
 * 
 * Used for: /home, /landing, /pricing, /features, /login, /register,
 *           /terms, /privacy, /legal, /risk-disclosure, /contact, /learn,
 *           /share/ai
 */
export const PublicLayout = () => {
  return (
    <BannerContextProvider>
      <ThemeProvider>
        <div
          className="text-light"
          style={{
            height: '100dvh',
            paddingTop: 'env(safe-area-inset-top)',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
        >
          <PublicBannerHost />
          <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <Outlet />
          </div>
        </div>
      </ThemeProvider>
    </BannerContextProvider>
  );
};
